var _g, _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgLock = function SvgLock(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 20,
    height: 20
  }, props), _g || (_g = /*#__PURE__*/React.createElement("g", {
    "data-name": "Group 12163",
    fill: "none"
  }, /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26842",
    d: "M0 0h20v20H0Z"
  }), /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26843",
    d: "M0 0h20v20H0Z",
    opacity: 0.87
  }))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    "data-name": "Path 26844",
    d: "M15 6.666h-.833V5a4.167 4.167 0 0 0-8.333 0v1.666H5a1.672 1.672 0 0 0-1.667 1.667v8.333A1.672 1.672 0 0 0 5 18.333h10a1.672 1.672 0 0 0 1.667-1.667V8.333A1.672 1.672 0 0 0 15 6.666ZM7.5 4.999a2.5 2.5 0 0 1 5 0v1.667h-5ZM15 16.666H5V8.333h10Zm-5-2.5A1.667 1.667 0 1 0 8.333 12.5 1.672 1.672 0 0 0 10 14.166Z",
    fill: "#7E81FF"
  })));
};
export default SvgLock;